import {
  parseCompany,
  parseCompanyEmails,
  parseCompanyTicket,
} from 'services/companyServices';

import { axiosWithToken } from './axios';

export const fetchGetCompanies = async () => {
  const response = await axiosWithToken.get(`company`);
  const companies = JSON.parse(response.data.body).companyProfiles;

  return companies.map((company) => parseCompany(company));
};

export const fetchGetCompany = async ({ id }) => {
  const response = await axiosWithToken.get(`company`, {
    params: { id },
  });
  const companies = JSON.parse(response.data.body).companyProfiles;

  return companies !== undefined
    ? companies.map((company) => parseCompany(company))[0]
    : {};
};

export const fetchAddCompany = async ({
  name,
  industry,
  address,
  address2,
  city,
  state,
  zip,
  phone,
  email,
  numberOfEmployees,
  website,
}) => {
  const response = await axiosWithToken.post(`company`, {
    name,
    industry,
    address,
    address2,
    city,
    state,
    zip,
    phone,
    email,
    number_of_employees: numberOfEmployees,
    website,
  });

  const company = JSON.parse(response.data.body).corporate_profile;

  return parseCompany(company);
};

export const fetchEditCompany = async (data) => {
  const response = await axiosWithToken.post(`company`, data);

  const company = JSON.parse(response.data.body).corporate_profile;

  return parseCompany(company);
};

export const fetchCompanyEmails = async (data) => {
  const response = await axiosWithToken.post('customer/mail/sent', data);

  const emails = JSON.parse(response.data.body).messages;

  return emails.map((email) => parseCompanyEmails(email));
};

export const fetchGetSupportTickets = async (companyId) => {
  const response = await axiosWithToken.get('customer/support/ticket', {
    params: { corporate_profile_id: companyId },
  });

  const { tickets } = JSON.parse(response.data.body);

  return tickets.map((ticket) => parseCompanyTicket(ticket));
};

export const fetchCreateSupportTicket = async (data) => {
  const response = await axiosWithToken.post(
    'customer/support/ticket/submit',
    data
  );

  const { ticket } = JSON.parse(response.data.body);

  return parseCompanyTicket(ticket);
};
